import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../../core/domain/events/domain_event_provider';
import { ThirdPartyEvent } from './third-party-events';

@Injectable({ providedIn: 'root' })
export class ThirdPartyEventProvider extends DomainEventProvider<ThirdPartyEvent> {}
